import { Button, Form, Modal, Upload, UploadFile } from "antd";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectOrganizationsProfile } from "../../organizationProfile/organizationProfileSlice";
import { UploadOutlined } from '@ant-design/icons';
import { BASE_PATH } from "../../../api/base";
import { getFromStorage } from "../../../app/helpers";
import { deleteFileAsync } from "../../files/FilesEntitySlice";
import { WasteManagementDocumentsColumns } from "../form/column";
import { CreateWasteManagementDocumentDto } from "../../../api/models/create-waste-management-document-dto";

interface WasteManagementDocumentsFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWasteManagementDocument: (values: CreateWasteManagementDocumentDto) => void;
  organizationId?: string;
}

export const WasteManagementDocumentsForm: React.FC<WasteManagementDocumentsFormProps> = ({ visible, setVisible, onCreateWasteManagementDocument, organizationId }) => {
  const [form] = Form.useForm<any>();

  const dispatch = useAppDispatch();
  const organization = useAppSelector(selectOrganizationsProfile);
  const onChange = (value: any, additional?: any) => {

    (Object.keys(form.getFieldsValue()) as (keyof CreateWasteManagementDocumentDto)[]).find((key) => {
      return form.getFieldsValue()[key] === value;
    });

  }

  const [ids, setIds] = useState<string[]>([]);
  const deleteFile = (id: string) => {
    return dispatch(deleteFileAsync({ id })).then((res: any) => {
      if (!res.error) {
        return true;
      }
      return false;
    });
  }

  const handleRemove = (file: UploadFile) => {
    if (file.response) {
      setIds(ids.filter(id => id === file.response.id));
      deleteFile(file.response.id)
    }
  };

  const onFinish = (value: any) => {
    const dto: CreateWasteManagementDocumentDto = {
      fileName: value.fileName,
      fileUrl: value.fileUrl,
      isActive: true,
      fileIds: ids,
      organizationId: organizationId,
    }
    onCreateWasteManagementDocument(dto);
}

  return (
    <Modal width="60%" open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form initialValues={{ bin: organization?.bin, organizationName: organization?.name }} form={form} className="p-8" layout="vertical" onFinish={onFinish}>
        {WasteManagementDocumentsColumns()
          .filter((column) => column.key !== "no")
          .map(({ title, dataIndex, rules, inputNode }, index) => (
            <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
              {
                React.cloneElement(
                  inputNode,
                  {
                    onChange: onChange
                  }
                )
              }
            </Form.Item>
          ))}
        <Upload
          action={`${BASE_PATH}/files/`}
          listType="picture"
          maxCount={1}
          headers={{
            Authorization: 'Bearer ' + getFromStorage("token"),
          }}
          onChange={(info) => {
            if (info.file.status === "done") {
                console.log(info.file.response.id)
                let temp = [...ids]
                temp.push(info.file.response?.id);
                setIds(temp);
              }
          }}
          onRemove={handleRemove}
        >
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload>
      </Form>
    </Modal>
  );
};
